<template>
    <div class="layout-breadcrumb">
        <div class="breadcrumb">
            <div class="route-bar-breadcrumb">
                <template v-for="(item, index) of items" :key="item">
                    <li>
                        <router-link :to="item.routerLink" class="p-link" v-if="item.routerLink">{{ item.label }}</router-link>
                        <template v-if="!item.routerLink">{{ item }}</template>
                    </li>
                    <li v-if="index !== 'label'"><i :class="['pi', { 'pi-angle-right': !$appState.isRTL, 'pi-angle-left': $appState.isRTL }]"></i></li>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { useLabelRenameStore } from '@/modules/label-rename/store';

export default {
    data() {
        return {
            home: { icon: 'pi pi-home', to: '/' },
            items: [],
        };
    },
    watch: {
        $route() {
            this.watchRouter();
        },
    },
    created() {
        this.watchRouter();
    },
    methods: {
        // Replace any overridden label (as a whole word) inside a breadcrumb string.
        applyLabelRename(text) {
            if (typeof text !== 'string' || !text) return text;
            const overrides = useLabelRenameStore().overrides;
            // Longer keys first so "Tasks" is replaced before "Task" (avoids partial-match bug).
            const keys = Object.keys(overrides).sort((a, b) => b.length - a.length);
            return keys.reduce(
                (acc, key) => acc.replace(new RegExp(`\\b${key}\\b`, 'g'), overrides[key]),
                text,
            );
        },
        mapBreadcrumbLabels(items) {
            if (!items || typeof items !== 'object') return items;
            const mapped = { ...items, label: this.applyLabelRename(items.label) };
            if (typeof mapped.parent === 'string') {
                mapped.parent = this.applyLabelRename(mapped.parent);
            } else if (mapped.parent && typeof mapped.parent === 'object') {
                mapped.parent = { ...mapped.parent, label: this.applyLabelRename(mapped.parent.label) };
            }
            return mapped;
        },
        watchRouter() {
            const breadcrumb = this.$router.currentRoute.value.meta.breadcrumb;
            if (breadcrumb) {
                this.items = this.mapBreadcrumbLabels(breadcrumb[0]);
            }
        },
    },
};
</script>
